<template>
  <nav class="navigation">
    <div class="container">
      <router-link to="/">
        <h5>Marias Opskrifter</h5>
      </router-link>
      <div class="menu" :class="{'show': toggleMenu}">
        <router-link to="/" exact>
          <li @click="resetCategoryData()">Søk</li>
        </router-link>
        <router-link
          v-for="(menuItem,i) in menuItems"
          :key="i"
          :to="{
            path: safeLink(menuItem),
          }"
        >
          <li @click="resetCategoryData(menuItem)">{{ menuItem }}</li>
        </router-link>
        <router-link v-if="hasPrivilege" to="/admin">
          <li @click="toggleMenu = false">Admin</li>
        </router-link>
      </div>
      <login />
      <fa icon="bars" class="menu-toggle" @click="toggleMenu = !toggleMenu" />
    </div>
  </nav>
</template>

<script>
import login from "@/components/common/Login";
export default {
  data() {
    return {
      toggleMenu: false
    };
  },
  computed: {
    menuItems() {
      return this.$store.getters.mainMenu;
    },
    hasPrivilege() {
      return this.$store.getters.hasPrivilege;
    }
  },
  methods: {
    resetCategoryData(item) {
      this.toggleMenu = false;
      const recipesToShow = item == undefined ? 20 : 21;
      this.$store.commit("setSearch", []);
      this.$store.commit("setNrOfRecipesToShow", recipesToShow);
      this.$store.dispatch("clearSelectedCategories");
    },
    safeLink(name) {
      return "/" + name.replace(" ", "-");
    }
  },
  components: {
    login
  }
};
</script>

<style lang="scss" scoped>
</style>